import {BasicEntity} from '../../framework/message/BasicEntity';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';
import {User} from '../../user/message/User';

export class Domain extends BasicEntity {
businessFormula: string;
code: string;
description: string;
label: TranslatedEmb;
ownerLogin: string;
users: User[];
}

